export function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
export function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-utilities/lib/util/errorHandling.js
// module id = 399
// module chunks = 0